// const named_defaults = {
//   solo_nationals: {
//     UIDEVENT: 'BAD3FD90-A412-5198-528B9EBA808A5BA5',
//     UIDEVENTPART: 'BAD4396B-B23F-7CE6-7C479F69C917966D',
//     UIDCLUB: '5132019D-F643-2BA2-BFB5090466305193',
//     DEFAULT_MAP_POSITION: [40.84945448792614, -96.76806163869597],
//     DEFAULT_RACING_TRACK_BOUNDS: [
//       [40.839658228207675, -96.77950859069824],
//       [40.839658228207675, -96.75920963287352],
//       [40.86283581665962, -96.75920963287352],
//       [40.86283581665962, -96.77950859069824],
//     ],
//     MAP_MIN_ZOOM_LEVEL: 15,
//     MAP_MAX_ZOOM_LEVEL: 20,
//     SHOW_PARKING_SPOTS_ZOOM_LEVEL: 18,
//     GOTO_SEARCHED_SPOT_ZOOM_LEVELL: 19,
//     SHOW_PARKING_SPOTS_MARKER_TEXT_ZOOM_LEVEL: 20,
//     LOGO_URLS_1X: {
//       Image: 'solo-nationals.png', // @1x
//       Image2: 'solo-nationals@2x.png', // @2x
//     },
//     CONTACT_INFO: {
//       name: 'Brian Harmer',
//       email: 'bharmer@scca.com',
//       telephone: '(785) 862-7145',
//     },
//   },
//   runoffs: {
//     UIDEVENT: '388A69BD-EDD4-A3C5-924A76DC9E67B870',
//     UIDEVENTPART: '389121F7-C646-BC90-5A0823A4CA0BF8B6',
//     UIDCLUB: '2D972A52-AEFB-C397-1165FF2693EB490F',
//     DEFAULT_MAP_POSITION: [36.56505, -79.20836],
//     DEFAULT_RACING_TRACK_BOUNDS: [
//       [36.54863847344638, -79.21751976013184],
//       [36.54863847344638, -79.19533252716064],
//       [36.572699052921095, -79.19533252716064],
//       [36.572699052921095, -79.21751976013184],
//     ],
//     MAP_MIN_ZOOM_LEVEL: 15,
//     MAP_MAX_ZOOM_LEVEL: 20,
//     SHOW_PARKING_SPOTS_ZOOM_LEVEL: 18,
//     GOTO_SEARCHED_SPOT_ZOOM_LEVELL: 19,
//     SHOW_PARKING_SPOTS_MARKER_TEXT_ZOOM_LEVEL: 20,
//     LOGO_URLS: {
//       Image: 'scca-runoffs.png', // @1x
//       Image2: 'scca-runoffs@2x.png', // @2x
//     },
//     CONTACT_INFO: {
//       name: 'SCCA Road Racing',
//       email: 'runoffs@scca.com',
//       telephone: '(785) 232-7229',
//     },
//   },
// }

// export const CONFIG_DATA = process.env.REACT_APP_CONFIG_DATA || {}
//
// if (Object.keys(CONFIG_DATA).length === 0) {
//   console.error(
//     `You must provide a valid config bundle REACT_APP_CONFIG_DATA.`
//   )
// }



export const UIDEVENT = process.env.REACT_APP_UIDEVENT;
export const UIDEVENTPART = process.env.REACT_APP_UIDEVENTPART;
export const UIDCLUB  = process.env.REACT_APP_UIDCLUB;
export const DEFAULT_MAP_POSITION = JSON.parse(process.env.REACT_APP_DEFAULT_MAP_POSITION);
export const DEFAULT_RACING_TRACK_BOUNDS = JSON.parse(process.env.REACT_APP_DEFAULT_RACING_TRACK_BOUNDS);
export const MAP_MIN_ZOOM_LEVEL = Number(process.env.REACT_APP_MAP_MIN_ZOOM_LEVEL);
export const MAP_MAX_ZOOM_LEVEL = Number(process.env.REACT_APP_MAP_MAX_ZOOM_LEVEL);
export const SHOW_PARKING_SPOTS_ZOOM_LEVEL = Number(process.env.REACT_APP_SHOW_PARKING_SPOTS_ZOOM_LEVEL);
export const SHOW_PARKING_SPOTS_MARKER_TEXT_ZOOM_LEVEL = Number(process.env.REACT_APP_SHOW_PARKING_SPOTS_MARKER_TEXT_ZOOM_LEVEL);
export const LOGO_URLS = { Image: process.env.REACT_APP_LOGO_URL_1X, Image2: process.env.REACT_APP_LOGO_URL_2X };
export const CONTACT_INFO = { name: process.env.REACT_APP_CONTACT_INFO_NAME, email: process.env.REACT_APP_CONTACT_INFO_EMAIL , telephone: process.env.REACT_APP_CONTACT_INFO_TELEPHONE };
export const GOTO_SEARCHED_SPOT_ZOOM_LEVEL = Number(process.env.REACT_APP_GOTO_SEARCHED_SPOT_ZOOM_LEVEL);
export const LOCK_PARKING_GROUP_NAME = process.env.REACT_APP_LOCK_PARKING_GROUP_NAME;


export const CALLBACK_URL =
  process.env.REACT_APP_CALLBACK_URL || 'http://localhost:3000'
export const API_BASE_URL =
  process.env.REACT_APP_API_BASE_URL ||
  'https://api-ci.msreg.dev/rest' //'https://api.msr.local/rest'
export const AUTHORIZATION_URL =
  process.env.REACT_APP_AUTHORIZATION_URL ||
  'https://ci.msreg.dev/index.cfm/event/oauth'


export const REQUEST_TOKEN_URL = `${API_BASE_URL}/tokens/request`
export const ACCESS_TOKEN_URL = `${API_BASE_URL}/tokens/access`

// window.CONFIG_NAME = CONFIG_NAME

console.log({
  UIDEVENT,
  UIDEVENTPART,
  UIDCLUB,
  CALLBACK_URL,
  API_BASE_URL,
  AUTHORIZATION_URL,
  REQUEST_TOKEN_URL,
  ACCESS_TOKEN_URL,
  GOTO_SEARCHED_SPOT_ZOOM_LEVEL,
  DEFAULT_MAP_POSITION,
  DEFAULT_RACING_TRACK_BOUNDS,
  MAP_MIN_ZOOM_LEVEL,
  MAP_MAX_ZOOM_LEVEL,
  SHOW_PARKING_SPOTS_ZOOM_LEVEL,
  SHOW_PARKING_SPOTS_MARKER_TEXT_ZOOM_LEVEL,
  env: process.env,
})

// api endpoints
export const USER_INFO_URL = `${API_BASE_URL}/me.json`

export const MAP_ATTRIBUTION =
  "&copy; <a href='//openstreetmap.org/copyright'>OpenStreetMap</a> contributors"
export const MAP_URL = 'https://tile.openstreetmap.org/{z}/{x}/{y}.png'
// export const MAP_URL = "http://{s}.tile.osm.org/{z}/{x}/{y}.png";
export const DEFAULT_STATE_INIT_INTERVAL = 60 //given in seconds
export const DEFAULT_USER_INIT_INTERVAL = 60 //given in seconds

export const UPDATE_CHANNEL_DEBOUNCE_INTERVAL =
  process.env.REACT_APP_UPDATE_DEBOUNCE_INTERVAL || 5 * 1000 //ms

export const CHECKOUT_EVENTS = {
  hold: 'hold',
  reserve: 'reserve',
  cancelHold: 'cancelHold',
  unreserve: 'unreserve',
  trade: 'trade',
}

export const IMAGE_RESIZE_OPTIONS = {
  searchResult: {
    sizes: [
      '/-/quality/lighter/-/progressive/yes/-/resize/40x40/-/format/png/',
      '/-/quality/lighter/-/progressive/yes/-/resize/80x80/-/format/png/',
    ],
    defaultClass: 'icon-profile-empty',
  },
  spotAttendee: {
    sizes: [
      '/-/quality/lighter/-/progressive/yes/-/resize/20x20/-/format/png/',
      '/-/quality/lighter/-/progressive/yes/-/resize/40x40/-/format/png/',
    ],
    defaultClass: 'icon-profile-empty-20',
  },
  drawer: {
    sizes: [
      '/-/quality/lighter/-/progressive/yes/-/resize/40x40/-/format/png/',
      '/-/quality/lighter/-/progressive/yes/-/resize/80x80/-/format/png/',
    ],
    defaultClass: 'icon-profile-empty',
  },
}



// WEBPACK FOOTER //
// ./src/constants/index.js